import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { foodstormRouter } from './routing/foodstormRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import EN_US from './translations/en-US.json'

// EN_US ships eagerly because insights-portal's SummaryPerformance widget composes
// this domain's educational banners into the Dashboard route; a lazy catalog would
// flash raw `foodstormDomain.*` ids until the banner-owning route was visited.
const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'foodstorm',
  routes,
  translations: {
    EN_US,
  },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [foodstormRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'foodstorm-dashboard-tool',
  },
}

export default definition
